import ACTIONS from './actions';

const appState = (
    state = { loggedInUser: false, headCoach: false, appError: false },
    action
) => {
    switch (action.type) {
        case ACTIONS.APP_ERROR: {
            return {
                ...state,
                appError: action.appError
            };
        }
        case ACTIONS.APP_LOADING: {
            return {
                ...state,
                appLoading: action.appLoading,
                appMessage: action.appMessage
            };
        }
        case ACTIONS.ANALYTICS_LOADING: {
            return {
                ...state,
                analyticsLoading: action.analyticsLoading,
                appMessage: action.appMessage
            };
        }
        case ACTIONS.APP_LOGIN_USER:
            return {
                ...state,
                loggedInUser: action.loggedInUser,
                role: action.role
            };
        case ACTIONS.APP_SET_IS_COACH:
            return {
                ...state,
                loggedInUser: {
                    ...state.loggedInUser,
                    isCoach: action.isCoach,
                    isBasic: action.isBasic,
                    isTrial: action.isTrial
                }
            };
        case ACTIONS.APP_LOGOUT_USER:
            return {
                ...state,
                loggedInUser: false,
                role: null
            };
        case ACTIONS.APP_SET_HEAD_COACH:
            return {
                ...state,
                headCoach: action.headCoach
            };
        case ACTIONS.APP_SET_LOGIN_MSG:
            return {
                ...state,
                loginMessage: action.message
            };
        case ACTIONS.APP_SET_USER_PREFS:
            return {
                ...state,
                userPrefs: action.userPrefs
            };
        case ACTIONS.APP_SET_USER_PROFILE:
            return {
                ...state,
                userProfile: action.userProfile
            };
        case ACTIONS.APP_UNAUTHORIZED_DIALOG:
            return {
                ...state,
                unauthorizedDialogOpen: action.unauthorizedDialogOpen
            };
        default:
            return state;
    }
};

export default appState;
